// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("omnes-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("omnes_medium-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("omnes-semibold-webfont.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #### Generated By: http://www.cufonfonts.com #### */

@font-face {
    font-family: 'Omnes Regular';
    font-style: normal;
    font-weight: normal;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}


@font-face {
    font-family: 'Omnes Medium';
    font-style: normal;
    font-weight: normal;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}


@font-face {
    font-family: 'Omnes Semibold';
    font-style: normal;
    font-weight: normal;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}
`, "",{"version":3,"sources":["webpack://./portal/static/fonts/omnes-pro/omnes-pro.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,2DAAqD;AACzD;;;AAGA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,2DAAoD;AACxD;;;AAGA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,2DAAsD;AAC1D","sourcesContent":["/* #### Generated By: http://www.cufonfonts.com #### */\n\n@font-face {\n    font-family: 'Omnes Regular';\n    font-style: normal;\n    font-weight: normal;\n    font-display: swap;\n    src: url('omnes-regular-webfont.woff') format('woff');\n}\n\n\n@font-face {\n    font-family: 'Omnes Medium';\n    font-style: normal;\n    font-weight: normal;\n    font-display: swap;\n    src: url('omnes_medium-webfont.woff') format('woff');\n}\n\n\n@font-face {\n    font-family: 'Omnes Semibold';\n    font-style: normal;\n    font-weight: normal;\n    font-display: swap;\n    src: url('omnes-semibold-webfont.woff') format('woff');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
